/* AppsWithImageHighlights.tsx generated by @compiled/babel-plugin v0.36.0 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { media } from '@atlaskit/primitives/responsive';
import { AppTile } from '@atlassian/mpac-app-tile';
import { BodyNormal, breakpointValues, FluidContainer, H4, LinkWithIcon, Skeleton, useResponsiveBreakpoint } from '@atlassian/mpac-primitives';
import React from 'react';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const _35 = "._4t3i1osq{height:100%}";
const _34 = "._1tke17pu{min-height:15.625rem}";
const _33 = "._p12f1dfx{max-width:32.5rem}";
const _32 = "._2rkogktf{border-radius:20px}";
const _31 = "@media not all and (min-width:64rem){._sp8t1ejb{padding-left:var(--ds-space-300,24px)}._axwi1ejb{padding-right:var(--ds-space-300,24px)}}";
const _30 = "@media not all and (min-width:48rem){._1rkb1osq{max-width:100%}._suga1txw{display:flex}._1o831wug{overflow-x:auto}._1jk9glyw{scrollbar-width:none}._3nz5glyw{ms-overflow-style:none}._z61jglyw::-webkit-scrollbar{display:none}._q71vidpf>a{flex-shrink:0}._1o44d60k>a{max-width:18.75rem}._1hir1wug>a{height:auto}}";
const _29 = "._19pk1ejb{margin-top:var(--ds-space-300,24px)}";
const _28 = "._1reoewfl{overflow-x:visible}";
const _27 = "._1bahv2br{justify-content:start}";
const _26 = "._yv0e9sye{grid-template-columns:repeat(2,minmax(0,1fr))}";
const _25 = "._1e0c11p5{display:grid}";
const _24 = "._zulp1ejb{gap:var(--ds-space-300,24px)}";
const _23 = "@media not all and (min-width:64rem){._3wvkidpf{margin-top:0}}";
const _22 = "@media not all and (min-width:48rem){._1mae1ejb{padding-left:var(--ds-space-300,24px)}}";
const _21 = "._19pkxy5q{margin-top:var(--ds-space-400,2pc)}";
const _20 = "._2lx21bp4{flex-direction:column}";
const _19 = "._i0dlf1ug{flex-basis:0%}";
const _18 = "._1o9zkb7n{flex-shrink:1}";
const _17 = "._16jlkb7n{flex-grow:1}";
const _16 = "@media (min-width:64rem) and (max-width:89.99rem){._123e1d4h{max-height:17.1875rem}}";
const _15 = "._5ral1dfr{object-fit:cover}";
const _14 = "._c71l1g4p{max-height:21.875rem}";
const _13 = "@media (min-width:64rem) and (max-width:89.99rem){._3vshidpf{padding-top:0}._op2cidpf{padding-right:0}._gos3idpf{padding-bottom:0}._50abidpf{padding-left:0}}";
const _12 = "@media not all and (min-width:64rem){._tl28idpf{padding-top:0}._1hwcidpf{padding-bottom:0}}";
const _11 = "._p12f1osq{max-width:100%}";
const _10 = "._4cvr1y6m{align-items:flex-start}";
const _9 = "._1bah1h6o{justify-content:center}";
const _8 = "._1yt4xy5q{padding:var(--ds-space-400,2pc)}";
const _7 = "@media not all and (min-width:64rem){._na0i1bp4{flex-direction:column}}";
const _6 = "._1p57xy5q{row-gap:var(--ds-space-400,2pc)}";
const _5 = "._2lx2vrvc{flex-direction:row}";
const _4 = "._4cvr1fhb{align-items:stretch}";
const _3 = "._kqswh2mm{position:relative}";
const _2 = "._1e0c1txw{display:flex}";
const container = null;
const titleDescriptionContainer = null;
const appGridSection = null;
const appGrid = null;
const skeletonStyles = null;
const exploreLinkContainer = null;
const imageContainer = null;
const imageStyles = null;
export const AppsWithImageHighlights = _ref => {
  let {
    apps,
    loading,
    environment,
    source,
    content,
    maxAppsToShow = 2,
    textColor,
    onLinkClick
  } = _ref;
  const {
    value: breakpoint
  } = useResponsiveBreakpoint();
  const isMobile = breakpoint < breakpointValues.sm;
  const Container = isMobile ? React.Fragment : FluidContainer;
  return /*#__PURE__*/_jsx(Container, {
    children: /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_2, _3, _4, _5, _6, _7]
      }), /*#__PURE__*/_jsxs("div", {
        className: ax(["_1e0c1txw _kqswh2mm _4cvr1fhb _2lx2vrvc _1p57xy5q _na0i1bp4"]),
        children: [/*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_8, _2, _9, _10, _11, _12, _13]
          }), /*#__PURE__*/_jsx("div", {
            className: ax(["_1yt4xy5q _1e0c1txw _1bah1h6o _4cvr1y6m _p12f1osq _tl28idpf _1hwcidpf _3vshidpf _op2cidpf _gos3idpf _50abidpf"]),
            children: /*#__PURE__*/_jsxs(CC, {
              children: [/*#__PURE__*/_jsx(CS, {
                children: [_11, _14, _15, _16]
              }), /*#__PURE__*/_jsx("img", {
                src: content.image,
                alt: content.title,
                className: ax(["_p12f1osq _c71l1g4p _5ral1dfr _123e1d4h"])
              })]
            })
          })]
        }), /*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_17, _18, _19, _2, _20]
          }), /*#__PURE__*/_jsxs("div", {
            className: ax(["_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx21bp4"]),
            children: [/*#__PURE__*/_jsxs(CC, {
              children: [/*#__PURE__*/_jsx(CS, {
                children: [_21, _22, _23]
              }), /*#__PURE__*/_jsxs("div", {
                className: ax(["_19pkxy5q _1mae1ejb _3wvkidpf"]),
                children: [/*#__PURE__*/_jsx(H4, {
                  style: {
                    color: textColor
                  },
                  as: "h3",
                  children: content.title
                }), /*#__PURE__*/_jsx(BodyNormal, {
                  style: {
                    color: textColor
                  },
                  children: content.description
                })]
              })]
            }), /*#__PURE__*/_jsxs(CC, {
              children: [/*#__PURE__*/_jsx(CS, {
                children: [_24, _25, _11, _26, _27, _28, _29, _30, _31]
              }), /*#__PURE__*/_jsx("div", {
                className: ax(["_zulp1ejb _1e0c11p5 _p12f1osq _yv0e9sye _1bahv2br _1reoewfl _19pk1ejb _1rkb1osq _suga1txw _1o831wug _1jk9glyw _3nz5glyw _z61jglyw _q71vidpf _1o44d60k _1hir1wug _sp8t1ejb _axwi1ejb"]),
                children: loading ? Array.from({
                  length: maxAppsToShow
                }).map((_, index) => /*#__PURE__*/_jsxs(CC, {
                  children: [/*#__PURE__*/_jsx(CS, {
                    children: [_32, _33, _34, _35]
                  }), /*#__PURE__*/_jsx(Skeleton, {
                    className: ax(["_2rkogktf _p12f1dfx _1tke17pu _4t3i1osq"])
                  }, index)]
                }, index)) : apps === null || apps === void 0 ? void 0 : apps.map((app, index) => /*#__PURE__*/_jsx(AppTile, {
                  tileData: app,
                  environment: environment,
                  source: source,
                  hideTagline: !isMobile,
                  a11yElementType: "h4"
                }, index))
              })]
            }), /*#__PURE__*/_jsxs(CC, {
              children: [/*#__PURE__*/_jsx(CS, {
                children: [_21, _22]
              }), /*#__PURE__*/_jsx("div", {
                className: ax(["_19pkxy5q _1mae1ejb"]),
                children: /*#__PURE__*/_jsx(LinkWithIcon, {
                  size: "medium",
                  type: "internal",
                  href: content.linkHref,
                  animateIcon: true,
                  underlineText: false,
                  "aria-label": content.linkAriaLabel,
                  onClick: onLinkClick,
                  children: content.linkText
                })
              })]
            })]
          })]
        })]
      })]
    })
  });
};